import { PrimaryButton } from '../Button/Buttons';
import { EmptyStateProps } from './EmptyState.types';

export function EmptyState({
  icon,
  title,
  description,
  buttonIcon,
  buttonText,
  action,
  onButtonClick,
  classes = 'flex-1'
}: EmptyStateProps) {
  const actionContent = () => {
    if (action) {
      return action;
    }

    if (buttonText && onButtonClick) {
      return (
        <PrimaryButton type="button" onClick={onButtonClick} icon={buttonIcon}>
          {buttonText}
        </PrimaryButton>
      );
    }

    return null;
  };

  return (
    <div
      className={`bg-white border border-gray-250v2 rounded-lg shadow-sm max-w-none w-full flex flex-col p-6 lg:p-16 h-full ${classes}`}
    >
      <div className="flex flex-col items-center justify-center flex-1">
        <div className="relative">
          <div className="w-12 h-12 flex items-center justify-center">
            {icon}
          </div>
        </div>
        <div className="flex flex-col items-center text-center mt-2 px-4">
          <h3 className="text-center font-sans font-medium text-sm leading-5 text-gray-900">
            {title}
          </h3>
          <p className="text-center mt-1 mb-6 font-sans font-normal text-sm leading-5 text-gray-500">
            {description}
          </p>
        </div>
        {actionContent()}
      </div>
    </div>
  );
}
